import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9da853a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mx-auto xl:w-1200px" }
const _hoisted_2 = { class: "text-2xl md:text-3xl text-black font-bold text-center mb-10" }
const _hoisted_3 = { class: "px-5 flex-row items-center justify-between pb-16 lg:flex xl:px-0" }
const _hoisted_4 = ["href", "target"]
const _hoisted_5 = { class: "flex flex-row items-center justify-between mb-5" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "coming-soon text-white rounded-lg h-6 leading-6 px-2 text-sm"
}
const _hoisted_8 = { class: "text-black ml-1 mb-4" }
const _hoisted_9 = { class: "text-2xl font-bold mb-3 text-center sm:text-left" }
const _hoisted_10 = { class: "text-base mb-7 text-center sm:text-left" }
const _hoisted_11 = { class: "flex flex-row items-center justify-center sm:justify-start text-xl" }
const _hoisted_12 = ["href", "target"]
const _hoisted_13 = ["src"]

import crossPng from '../images/cross.png'
import swapPng from '../images/swap.png'
import financialPng from '../images/financial.png'
import moreSectionBack from '../images/more-section-back.png'
import sdkArrowRightLogo from '../images/sdk-arrow-right.svg'
import sdkMobileArrowRightLogo from '../images/sdk-mobile-arrow-right.png'
import sdkEntryBackPng from '../images/sdk-entry-back.png'
import sdkEntryMobileBackPng from '../images/sdk-entry-mobile-back.png'
import { computed, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { isProd, isMobile } from '../constants'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { t, locale } = useI18n()
const windowWidth = ref(document.documentElement.offsetWidth)
const host = isProd ? 'https://app.everpay.io' : 'https://app-dev.everpay.io'

const moreItems = [
  {
    name: 'cross',
    img: crossPng,
    url: `${host}/deposit`
  },
  {
    name: 'swap',
    img: swapPng,
    url: `${host}/swap`
  },
  {
    name: 'financial_management',
    img: financialPng
  }
]

const sdkEntries = computed(() => {
  return [
    {
      title: t('develop_integration.docs'),
      url: `https://docs.everpay.io${locale.value.includes('zh') ? '' : '/en'}`
    },
    {
      title: t('develop_integration.everpayjs'),
      url: `https://docs.everpay.io${locale.value.includes('zh') ? '' : '/en'}/docs/guide/SDK/intro`
    }
  ]
})

const sdkEntryBack = computed(() => {
  return windowWidth.value < 640 ? sdkEntryMobileBackPng : sdkEntryBackPng
})
const sdkArrowRight = computed(() => {
  return windowWidth.value < 640 ? sdkMobileArrowRightLogo : sdkArrowRightLogo
})

onMounted(() => {
  window.addEventListener('resize', () => {
    windowWidth.value = document.documentElement.offsetWidth
  })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "pt-16 sm:pb-16 lg:py-32 bg-cover bg-no-repeat bg-top",
    style: _normalizeStyle(`background-image:url(${_unref(moreSectionBack)});`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(t)('more_functions.title')), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(moreItems, (item, index) => {
          return _createElementVNode("a", {
            key: index,
            class: "more-item bg-white rounded-xl block px-8 py-6 text-black relative mb-4 md:py-10 md:px-6 lg:mb-0 last:mb-0",
            href: item.url ? item.url : 'javascript:void(0);',
            target: !_unref(isMobile) && item.url ? '_blank' : ''
          }, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("img", {
                src: item.img,
                class: "w-12 h-12 block"
              }, null, 8, _hoisted_6),
              (!item.url)
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_unref(t)('coming_soon')), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("h3", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_unref(t)(`more_functions.${item.name}`)), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["more-item-desc ml-1 text-sm lg:w-64 xl:w-72", !_unref(locale).includes('zh') ? 'h-28 sm:h-16 md:h-24' : 'h-16'])
            }, _toDisplayString(_unref(t)(`more_functions.${item.name}_desc`)), 3)
          ], 8, _hoisted_4)
        }), 64))
      ]),
      _createElementVNode("div", {
        class: "text-white mx-0 pt-16 pb-48 px-5 bg-no-repeat bg-right-bottom bg-cover sm:rounded-xl sm:py-12 sm:px-14 sm:mx-5 md:rounded-2xl lg:rounded-3xl xl:mx-0",
        style: _normalizeStyle(`
          background-image: url(${_unref(sdkEntryBack)}),
          ${windowWidth.value < 640 ? 'linear-gradient(90deg, #5356bd 0%, #9f89d3 100%)' : 'linear-gradient(135deg, #5356bd 0%, #a78fd6)'};
        `)
      }, [
        _createElementVNode("h3", _hoisted_9, _toDisplayString(_unref(t)('develop_integration.title')), 1),
        _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(t)('develop_integration.desc')), 1),
        _createElementVNode("div", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sdkEntries), (sdkEntry, index) => {
            return (_openBlock(), _createElementBlock("a", {
              key: index,
              style: _normalizeStyle(`${windowWidth.value < 640 ? 'background: linear-gradient(90deg, #ebdff8 0%,#e8eef7 67%, #ddf2fb);' : ''}`),
              class: "sdk-item rounded-lg py-2 px-3 text-base sm:text-lg mr-14 flex flex-row items-center justify-start sm:p-0 last:mr-0",
              href: sdkEntry.url,
              target: !_unref(isMobile) ? '_blank' : ''
            }, [
              _createElementVNode("span", {
                style: _normalizeStyle(`${windowWidth.value < 640 ? 'background: linear-gradient(98.82deg, #5356BD 1.77%,#9B81E6 95.45%);-webkit-background-clip: text;color: transparent;' : 'color:#D2D1FF;'}`),
                class: "mr-1.5"
              }, _toDisplayString(sdkEntry.title), 5),
              _createElementVNode("img", {
                class: "block w-4",
                src: _unref(sdkArrowRight)
              }, null, 8, _hoisted_13)
            ], 12, _hoisted_12))
          }), 128))
        ])
      ], 4)
    ])
  ], 4))
}
}

})